// Turnover Player Select
export var TurnoverPlayer = {
  name: "turnover-player",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "turnover.select-player",
  showOn: [{ state: "primary", value: "turnover-player", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  cancelActions: [
    {
      actions: [
        {
          action: "setPossession",
          value: { currentEntity: true },
          type: "main",
        },
      ],
      conditions: [
        {
          item: "options",
          value: "isDefensive",
          event: "main",
          operator: "is",
        },
      ],
    },
  ],
  showDetails: { events: ["main"] },
  children: [
    {
      name: "turnover-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      startEvent: false,
      startPlay: false,
      showOn: [true],
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
      },
      actionGroups: [
        {
          actions: [
            {
              action: "clearData",
              value: ["subType", "scores", "success"],
              type: "main",
            },
            { action: "clearEvent", value: "rebound", type: "main" },
            {
              action: "nextState",
              value: "turnover-type",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
    {
      name: "team-turnover-button",
      component: "TypeButton",
      layout: "match-button center",
      mode: "enable",
      text: "turnover.team",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      actionGroups: [
        {
          actions: [
            {
              action: "clearData",
              value: ["subType", "scores", "success"],
              type: "main",
            },
            { action: "saveData", value: null, type: "personId" },
            {
              action: "saveData",
              value: [{ option: "team", value: true }],
              type: "options",
            },
            { action: "clearEvent", value: "rebound", type: "main" },
            {
              action: "nextState",
              value: "turnover-type",
              type: "primary",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
